module.exports = __webpack_public_path__ + "img/mv_list_left_pc.a9024722.svg";